import UNIT_TYPES from "./units";

// Улучшения в катапульту (d4) на 2 монеты дешевле прежних — вместе с ее наймом
// (см. UNIT_TYPES.D4). Старые записи списывают цену из действия UNIT_UPGRADE
export const UNIT_UPGRADES = {
  [UNIT_TYPES.D6.id]: [{
    toId: UNIT_TYPES.D10.id,
    price: 5,
  }, {
    toId: UNIT_TYPES.D20.id,
    price: 10,
  }, {
    toId: UNIT_TYPES.D8.id,
    price: 8,
  }, {
    toId: UNIT_TYPES.D12.id,
    price: 12,
  }, {
    toId: UNIT_TYPES.D4.id,
    price: 10,
  }],
  [UNIT_TYPES.D10.id]: [{
    toId: UNIT_TYPES.D20.id,
    price: 8,
  }, {
    toId: UNIT_TYPES.D8.id,
    price: 6,
  }, {
    toId: UNIT_TYPES.D12.id,
    price: 10,
  }, {
    toId: UNIT_TYPES.D4.id,
    price: 8,
  }],
  [UNIT_TYPES.D8.id]: [{
    toId: UNIT_TYPES.D10.id,
    price: 2,
  }, {
    toId: UNIT_TYPES.D20.id,
    price: 8,
  }, {
    toId: UNIT_TYPES.D12.id,
    price: 4,
  }, {
    toId: UNIT_TYPES.D4.id,
    price: 6,
  }],
  [UNIT_TYPES.D12.id]: [{
    toId: UNIT_TYPES.D20.id,
    price: 6,
  }, {
    toId: UNIT_TYPES.D4.id,
    price: 4,
  }],
  [UNIT_TYPES.D4.id]: [{
    toId: UNIT_TYPES.D20.id,
    price: 8,
  }, {
    toId: UNIT_TYPES.D12.id,
    price: 8,
  }],
}